var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTourguideIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tour-guide 1",
    clipPath: "url(#clip0_15_179)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.5496 21.3426L14.4824 21.6218L18.3317 24.2561L22.1799 21.6221L22.1139 21.3425C19.7372 22.5337 16.9262 22.5336 14.5496 21.3426Z",
    fill: "#EB691E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.3319 0C14.6044 0 12.1656 2.76579 11.6504 6.35294H25.0134C24.4981 2.76579 22.0593 0 18.3319 0Z",
    fill: "#EB691E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M25.7439 8.4707H10.9204L8.80273 11.6472H27.8616L25.7439 8.4707Z",
    fill: "#EB691E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.2148 31.7646H20.4501V35.9999H16.2148V31.7646Z",
    fill: "#EB691E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M17.2733 25.9774C16.7029 25.5955 12.3311 22.6687 11.6803 22.2329C7.72628 22.39 4.56738 25.6456 4.56738 29.6387V35.9916H8.80268V31.7648H10.9203V35.9916H14.0968V29.6471H17.2733V25.9774Z",
    fill: "#EB691E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M24.9838 22.2329C24.838 22.3306 20.1718 25.4543 19.3906 25.9773V29.6471H22.5671V35.9916H25.7436V31.7648H27.8612V35.9916H32.0965V29.6387C32.0965 25.654 28.9464 22.3907 24.9838 22.2329Z",
    fill: "#EB691E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M24.6854 13.7646H11.9795C11.9795 17.2733 14.8238 20.1176 18.3324 20.1176C21.8411 20.1176 24.6854 17.2733 24.6854 13.7646Z",
    fill: "#EB691E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15_179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0.332031)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTourguideIcon);
export default __webpack_public_path__ + "static/media/tourguide_icon.2f6ea6a6610b8d94d0553e4d4d2ebb25.svg";
export { ForwardRef as ReactComponent };